import { fetchMyAchievements } from '../infrastructure/rankingApi';

const SERVER_STORAGE_KEY = 'nacanaca-achievements-server-v2';

export const ACHIEVEMENT_GROUPS = {
  solo: 'Partidas en solitario',
  duelos: 'Duelos',
  exploracion: 'Exploración y señales',
};

export const ACHIEVEMENTS = [
  { id: 'primer-ritual', title: 'Primer ritual', description: 'Completa tu primera partida en solitario.', icon: '✦', goal: 1, group: 'solo', progress: (stats) => stats.soloGames },
  { id: 'primer-corte', title: 'Primer corte', description: 'Acierta tu primera señal.', icon: '⚡', goal: 1, group: 'exploracion', progress: (stats) => stats.totalHits },
  { id: 'primer-duelo', title: 'Primer duelo', description: 'Completa tu primer duelo.', icon: '✦', goal: 1, group: 'duelos', progress: (stats) => stats.duelGames },
  { id: 'primera-victoria', title: 'Primera victoria', description: 'Gana tu primera partida, en solitario o en duelo.', icon: '★', goal: 1, group: 'solo', progress: (stats) => stats.totalWins },
  { id: 'provocador', title: 'Provocador', description: 'Reta a 5 personas distintas.', icon: '⚔', goal: 5, group: 'duelos', progress: (stats) => stats.rivals.length },
  { id: 'duelista', title: 'Duelista', description: 'Reta a 10 personas distintas.', icon: '❖', goal: 10, group: 'duelos', progress: (stats) => stats.rivals.length },
  { id: 'leyenda-del-duelo', title: 'Leyenda del duelo', description: 'Reta a 20 personas distintas.', icon: '♛', goal: 20, group: 'duelos', progress: (stats) => stats.rivals.length },
  { id: 'conquistador', title: 'Conquistador', description: 'Maldecir 3 zonas distintas con GPS.', icon: '♜', goal: 3, group: 'exploracion', progress: (stats) => stats.zones.length },
  { id: 'cartografo', title: 'Cartógrafo maldito', description: 'Conquista las 5 zonas de Toluca con GPS.', icon: '⌖', goal: 5, group: 'exploracion', progress: (stats) => stats.zones.length },
  { id: 'zona-centro', title: 'Centro explorado', description: 'Juega en Zona Centro con GPS.', icon: '⌖', goal: 1, group: 'exploracion', progress: (stats) => Number(stats.zones.includes('centro')) },
  { id: 'zona-norte', title: 'Norte explorado', description: 'Juega en Zona Norte con GPS.', icon: '⌖', goal: 1, group: 'exploracion', progress: (stats) => Number(stats.zones.includes('norte')) },
  { id: 'zona-tollocan', title: 'Tollocan explorado', description: 'Juega en Zona Tollocan con GPS.', icon: '⌖', goal: 1, group: 'exploracion', progress: (stats) => Number(stats.zones.includes('tollocan')) },
  { id: 'zona-ceu', title: 'C.U. explorada', description: 'Juega en Zona C.U. con GPS.', icon: '⌖', goal: 1, group: 'exploracion', progress: (stats) => Number(stats.zones.includes('ceu')) },
  { id: 'zona-parque', title: 'Sierra Morelos explorado', description: 'Juega en Parque Sierra Morelos con GPS.', icon: '⌖', goal: 1, group: 'exploracion', progress: (stats) => Number(stats.zones.includes('parque')) },
  { id: 'imparable', title: 'Imparable', description: 'Gana 10 partidas en solitario seguidas.', icon: '☠', goal: 10, group: 'solo', progress: (stats) => stats.bestSoloWinStreak },
  { id: 'ritmo-infernal', title: 'Ritmo infernal', description: 'Alcanza 250 puntos en una partida en solitario.', icon: '♨', goal: 250, group: 'solo', progress: (stats) => stats.bestSoloScore },
  { id: 'pulso-de-acero', title: 'Pulso de acero', description: 'Mantén una racha de 30 segundos.', icon: '◇', goal: 30, group: 'exploracion', progress: (stats) => stats.bestStreakTime },
  { id: 'cazador-de-senales', title: 'Cazador de señales', description: 'Acumula 100 aciertos.', icon: '✹', goal: 100, group: 'exploracion', progress: (stats) => stats.totalHits },
  { id: 'calaverita', title: 'Calaverita', description: 'Pierde 5 duelos. La muerte también juega.', icon: '💀', goal: 5, group: 'duelos', progress: (stats) => stats.duelLosses },
  { id: 'coleccionista-de-almas', title: 'Coleccionista de almas', description: 'Encuentra 100 veces puntos ocultos en el mapa.', icon: '👻', goal: 100, group: 'exploracion', progress: (stats) => stats.hiddenFinds },
  { id: 'ojos-de-tecolote', title: 'Ojos de tecolote', description: 'Encuentra 500 veces puntos ocultos. El tecolote todo lo ve.', icon: '🦉', goal: 500, group: 'exploracion', progress: (stats) => stats.hiddenFinds },
];

const currentPlayerId = () => {
  try {
    const player = JSON.parse(localStorage.getItem('nacanaca-player-data') || 'null');
    return Number.isInteger(player?.id) ? String(player.id) : '';
  } catch {
    return '';
  }
};

export const loadServerProgress = () => {
  try {
    const playerId = currentPlayerId();
    const byPlayer = JSON.parse(localStorage.getItem(SERVER_STORAGE_KEY) || '{}');
    const saved = playerId ? byPlayer[playerId] : null;
    return saved?.playerId === Number(playerId) && saved?.stats ? saved : null;
  } catch {
    return null;
  }
};

const saveServerProgress = (payload) => {
  try {
    const playerId = String(payload.playerId || '');
    if (!playerId || playerId !== currentPlayerId()) return false;
    const byPlayer = JSON.parse(localStorage.getItem(SERVER_STORAGE_KEY) || '{}');
    byPlayer[playerId] = { playerId: payload.playerId, stats: payload.stats, at: Date.now() };
    localStorage.setItem(SERVER_STORAGE_KEY, JSON.stringify(byPlayer));
  } catch {
    return false;
  }
  window.dispatchEvent(new CustomEvent('nacanaca-achievements-updated'));
  return true;
};

// El servidor es la única fuente de medallas. La caché solo evita parpadeos y
// queda separada por id de jugador; nunca se mezcla con resultados locales.
export const syncAchievementsFromServer = async () => {
  const payload = await fetchMyAchievements();
  if (!payload || !Number.isInteger(payload.playerId) || !payload.stats) {
    throw new Error('Respuesta de logros inválida.');
  }
  if (!saveServerProgress(payload)) throw new Error('La respuesta pertenece a otra sesión.');
  return payload;
};

export const getAchievementStats = (server = loadServerProgress()) => {
  const serverStats = server?.stats;
  return {
    gamesPlayed: Number(serverStats?.gamesPlayed) || 0,
    soloGames: Number(serverStats?.soloGames) || 0,
    duelGames: Number(serverStats?.duelGames) || 0,
    totalHits: Number(serverStats?.totalHits) || 0,
    totalWins: Number(serverStats?.totalWins) || 0,
    soloWins: Number(serverStats?.soloWins) || 0,
    duelWins: Number(serverStats?.duelWins) || 0,
    totalLosses: Number(serverStats?.totalLosses) || 0,
    soloLosses: Number(serverStats?.soloLosses) || 0,
    duelLosses: Number(serverStats?.duelLosses) || 0,
    bestScore: Number(serverStats?.bestScore) || 0,
    bestSoloScore: Number(serverStats?.bestSoloScore) || 0,
    // El total oficial ya incluye los puntos ocultos verificados en servidor.
    totalScore: Number(serverStats?.totalScore) || 0,
    hiddenPoints: Number(serverStats?.hiddenPoints) || 0,
    // Los logros cuentan hallazgos (uno por punto encontrado), no los
    // puntos que cada hallazgo otorga al puntaje oficial.
    hiddenFinds: Number(serverStats?.hiddenFinds) || 0,
    bestStreakTime: Number(serverStats?.bestStreakSec) || 0,
    bestWinStreak: Number(serverStats?.bestWinStreak) || 0,
    bestSoloWinStreak: Number(serverStats?.bestSoloWinStreak) || 0,
    zones: Array.isArray(serverStats?.zones) ? serverStats.zones : [],
    rivals: Array.isArray(serverStats?.rivals) ? serverStats.rivals : [],
  };
};

export const getAchievementState = () => {
  const stats = getAchievementStats();
  return ACHIEVEMENTS.map((achievement) => {
    const current = Math.min(achievement.progress(stats), achievement.goal);
    return { ...achievement, current, unlocked: current >= achievement.goal };
  });
};
